import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

const SET_CLIENTE = (state,cliente) => {
	state.logged = cliente

	if(cliente && cliente.google_analytics_key){
		Vue.use(VueAnalytics, {
		 	id: cliente.google_analytics_key,
			linkers: [cliente.url_web, cliente.url_empresa, cliente.url_credenciada, cliente.url_parceiro],
			checkDuplicatedScript: true
		})
	}
}

const SET_TENANT = (state, tenant) => {
	state.tenant = tenant
}


export{
	SET_CLIENTE,
	SET_TENANT
}



// WEBPACK FOOTER //
// ./src/store/cliente/mutations.js